import Swal from "sweetalert2";

export function showPhenoDescriptionSwal(item) {
  let text = getPhenoMoreInfo(item);
  Swal.fire({
    title:
      '<h6 style="font-family: Ubuntu; font-size: 20px;">Phenotype Information</h6>',
    html: `<div style="text-align: left; font-size: 13px; font-family: Ubuntu;">${text}</div>`,
    confirmButtonText: "Close",
    customClass: {
      title: "swal-title",
      text: "swal-text",
      confirmButton: "swal-confirm-button",
    },
    position: "center",
    iconColor: "#A51C30",
    width: 1000,
  });
}

function getPhenoMoreInfo(pheno) {
  const fields = {
    PhenoID: "Phenotype ID",
    phenocode: "PhenoCode",
    description: "Description",
    description_more: "Description More",
    coding_description: "Coding Description",
    category: "Category",
    n_cases_EUR: "Number of Cases",
    n_controls_EUR: "Number of Controls",
    trait_type: "Trait Type",
    pheno_sex: "Sex",
    coding: "Coding",
    modifier: "Modifier",
    phenotype_qc_EUR: "Quality Control",
    sldsc_25bin_h2_observed_EUR: "h<sup>2</sup> (Observed)",
    sldsc_25bin_h2_liability_EUR: "h<sup>2</sup> (Liability)",
    sldsc_25bin_h2_z_EUR: "z-score for h<sup>2</sup>",
    lambda_gc_EUR: "λ<sub>GC</sub>",
  };

  let text = `<table id="pheno_more" style="border-collapse: collapse; width: 940px; font-family: Ubuntu; text-align: left; font-size: 13px;">
                    <thead>
              <tr style="background-color: #f2f2f2;">
                <th style="border: 1px solid #ddd; padding: 8px; width: 80px; text-align: justify;">Attribute Name</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: justify; width: 230px;">Attribute Value</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: justify; width: 50px;">Source</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: justify; width: 150px;">Attribute Definition</th>
              </tr>
            </thead>    
        <tbody>`;

  for (const [field, label] of Object.entries(fields)) {
    if (pheno[field] && pheno[field] !== undefined && pheno[field] !== null) {
      if (field === "phenocode") {
        text += `<tr>
                <td style="border: 1px solid #ddd; padding: 8px;">${fields["phenocode"]}</td>
                <td style="border: 1px solid #ddd; padding: 8px;"><a class="resource" style="color: #A51C30; text-decoration: none; font-size: 13px;" href="${pheno["phenocode_link"]}" target="_blank">${pheno["phenocode"]}</a></td>
              `;
      } else {
        text += `<tr>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: justify;">${label}</td>
                <td style="border: 1px solid #ddd; padding: 8px;">${pheno[field]}</td>
              `;
      }

      if (field == "phenocode") {
        text += '<td style="border: 1px solid #ddd; padding: 8px;">UKBB</td>';
      } else if (field == "PhenoID") {
        text += '<td style="border: 1px solid #ddd; padding: 8px;">AGES</td>';
      } else {
        text += `<td style="border: 1px solid #ddd; padding: 8px;">Pan-UKBB</td>`;
      }

      if (field == "lambda_gc_EUR") {
        text += '<td style="border: 1px solid #ddd; padding: 8px;">Quantifies the extent to which median association of SNPs to this phenotype is inflated relative to chance. Large values ( λ<sub>GC</sub> &gt; 1.05 ) of this statistic could indicate the statistical confounders in the association study or indicate the phenotype is truly influenced by many genetic variants.</td>';
      } else if (field == "sldsc_25bin_h2_observed_EUR") {
        text += '<td style="border: 1px solid #ddd; padding: 8px;">Heritability estimated from observed data.</td>';
      } else if (field == "phenotype_qc_EUR") {
        text += '<td style="border: 1px solid #ddd; padding: 8px;">Indicates whether the phenotype did or did not pass quality control.</td>';
      } else if (field == "sldsc_25bin_h2_liability_EUR") {
        text += '<td style="border: 1px solid #ddd; padding: 8px;">Heritability on the "liability threshold scale". Heritability of categorical phenotypes is computed by converting traits to the "liability threshold scale".</td>';
      } else if (field == "pheno_sex") {
        text += '<td style="border: 1px solid #ddd; padding: 8px;">Sex of the individuals included in the phenotype association study.</td>';
      } else {
        text += '<td style="border: 1px solid #ddd; padding: 8px;">NA</td>';
      }


      text += '</tr>'
    }
  }

  return text + "</tbody></table>";
}
